export default "__VITE_ASSET__fcb576c6__"